export const SHOP_REQUEST_TIMEOUT = 30_000;
export class ShopTimeoutError extends Error {
  constructor() { super("This is taking too long. Reload to check the result, then try again."); }
}

/** Bound even a transport that ignores abort; late responses cannot settle a timed-out read. */
export function shopRequest<T>(read: (signal: AbortSignal) => Promise<T>, signal?: AbortSignal, timeout = SHOP_REQUEST_TIMEOUT): Promise<T> {
  return new Promise((resolve, reject) => {
    const controller = new AbortController();
    const cancel = () => { controller.abort(); finish(); reject(new DOMException("Request cancelled", "AbortError")); };
    const timer = setTimeout(() => { controller.abort(); finish(); reject(new ShopTimeoutError()); }, timeout);
    const finish = () => { clearTimeout(timer); signal?.removeEventListener("abort", cancel); };
    if (signal?.aborted) { cancel(); return; }
    signal?.addEventListener("abort", cancel, { once: true });
    void Promise.resolve().then(() => {
      if (controller.signal.aborted) throw new DOMException("Request cancelled", "AbortError");
      return read(controller.signal);
    }).then(value => { finish(); resolve(value); }, error => { finish(); reject(error); });
  });
}
